const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Pix32 = function Pix32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.18 7.22c.705 0 1.37.275 1.869.774l2.71 2.71a.502.502 0 0 0 .709 0l2.7-2.7a2.629 2.629 0 0 1 1.87-.774h.325l-3.43-3.43a2.734 2.734 0 0 0-3.867.001l-3.419 3.42h.532zm9.858 9.55c-.707 0-1.37-.275-1.87-.774l-2.7-2.7a.513.513 0 0 0-.71 0l-2.71 2.71a2.625 2.625 0 0 1-1.869.774h-.532l3.42 3.42a2.735 2.735 0 0 0 3.867 0l3.429-3.43h-.325zm1.089-8.776 2.072 2.072a2.735 2.735 0 0 1 0 3.868l-2.072 2.072a.394.394 0 0 0-.147-.03h-.942c-.488 0-.964-.197-1.309-.542l-2.7-2.7c-.489-.49-1.342-.489-1.832 0l-2.71 2.71a1.862 1.862 0 0 1-1.308.542h-1.158a.394.394 0 0 0-.14.028l-2.08-2.08a2.734 2.734 0 0 1 0-3.868l2.08-2.08c.044.016.09.028.14.028h1.158c.487 0 .964.198 1.308.542l2.71 2.71a1.296 1.296 0 0 0 1.833-.001l2.7-2.7a1.862 1.862 0 0 1 1.308-.541h.942a.395.395 0 0 0 .147-.03z",
      fill: "#32BCAD",
    })
  );
};
Pix32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Pix24 = function Pix24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M17.89 6.158c-.865 0-1.675.335-2.285.945l-3.312 3.312a.614.614 0 0 1-.867 0l-3.3-3.3a3.211 3.211 0 0 0-2.284-.945h-.397l4.19-4.191a3.34 3.34 0 0 1 4.724 0l4.179 4.179h-.649zM5.842 17.826c.862 0 1.674-.336 2.284-.945l3.3-3.3a.625.625 0 0 1 .867 0l3.312 3.312a3.21 3.21 0 0 0 2.284.945h.652l-4.182 4.179a3.34 3.34 0 0 1-4.725 0l-4.189-4.191h.397z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.473 7.14 1.98 9.633a3.34 3.34 0 0 0 0 4.725l2.494 2.497h1.369c.595 0 1.177-.242 1.598-.663l3.298-3.298c.598-.597 1.643-.597 2.24 0l3.31 3.31a2.278 2.278 0 0 0 1.599.663h1.62l2.51-2.509a3.34 3.34 0 0 0 0-4.725L19.51 7.127h-1.62c-.596 0-1.178.242-1.6.664l-3.312 3.312a1.575 1.575 0 0 1-1.119.463 1.58 1.58 0 0 1-1.118-.463l-3.3-3.3a2.277 2.277 0 0 0-1.6-.664H4.474z",
      fill: "currentColor",
    })
  );
};
Pix24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  32: Pix32,
  24: Pix24,
};
export function Pix(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Pix' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
